import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { whitepaperAPI } from '../services/api';
import './News.css';

const Resources = () => {
  const [whitepapers, setWhitepapers] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchWhitepapers();
  }, []);

  const fetchWhitepapers = async () => {
    setLoading(true);
    try {
      const res = await whitepaperAPI.getList();
      setWhitepapers(res.data || []);
    } catch (error) {
      setWhitepapers([]);
    } finally {
      setLoading(false);
    }
  };

  const handleDownload = (id) => {
    window.open(whitepaperAPI.getDownloadUrl(id), '_blank');
  };

  const getCoverEmoji = (index) => {
    const emojis = ['📘', '📗', '📕', '📙'];
    return emojis[index % emojis.length];
  };

  return (
    <div className="news-page">
      {/* Hero Section */}
      <section className="news-hero page-hero hero-tone-violet">
        <div className="page-hero-pattern"></div>
        <div className="container">
          <span className="hero-eyebrow">产品动态 · 行业洞察</span>
          <h1 className="page-title">信息与资源</h1>
          <p className="page-subtitle">了解产品动态与行业洞察</p>
        </div>
      </section>

      {/* Tabs */}
      <section className="tabs-section">
        <div className="container">
          <div className="news-tabs">
            <Link to="/news" className="news-tab">信息发布</Link>
            <Link to="/resources" className="news-tab active">资源下载</Link>
          </div>
        </div>
      </section>

      {/* Content */}
      <section className="content-section">
        <div className="container">
          {loading ? (
            <div style={{ textAlign: 'center', padding: '40px' }}>加载中...</div>
          ) : (
            <div className="whitepapers-grid">
              {whitepapers.map((paper, index) => (
                <div key={paper._id} className="whitepaper-card" style={{ animationDelay: `${index * 0.1}s` }}>
                  <div className="paper-cover">{getCoverEmoji(index)}</div>
                  <div className="paper-info">
                    <h3 className="paper-title">{paper.title}</h3>
                    <p className="paper-desc">{paper.description}</p>
                    <div className="paper-meta">
                      <span className="paper-date">{paper.date}</span>
                    </div>
                    <button className="download-btn" onClick={() => handleDownload(paper._id)}>
                      下载
                    </button>
                  </div>
                </div>
              ))}
              {whitepapers.length === 0 && (
                <div style={{ textAlign: 'center', padding: '40px', color: '#999', gridColumn: '1 / -1' }}>
                  暂无文档
                </div>
              )}
            </div>
          )}
        </div>
      </section>

      {/* CTA Section */}
      <section className="news-cta">
        <div className="container">
          <h2>获取最新动态</h2>
          <p>关注公众号，获取产品更新与行业洞察</p>
          <a href="/contact" className="btn btn-primary btn-lg">联系我们</a>
        </div>
      </section>
    </div>
  );
};

export default Resources;